var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg23Rotated = function Svg23Rotated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 9,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.201 6.781a.799.799 0 1 1 0 1.598H.8a.799.799 0 1 1 0-1.598zm0-6.39a.799.799 0 1 1 0 1.597H.8A.799.799 0 1 1 .8.391z",
    fill: "#BABABA"
  })));
};

export default Svg23Rotated;